import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { RouterModule } from '@angular/router';
import { LayoutHeaderComponent } from './layout-header/layout-header.component';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '../pages/components/notifications/notifications.component';

@NgModule({
  declarations: [
    LayoutComponent,
    SidemenuComponent,
    LayoutHeaderComponent,
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    // NotificationsModule
  ]
})
export class LayoutModule { }
